const initialTestimonials = {
  isLoading: false,
  result: [],
};

export default initialTestimonials;
